export function removeEmpty<T extends object>(obj: T) {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      const value = (obj as Record<string, unknown>)[key];
      if (
        value == null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        delete (obj as Record<string, unknown>)[key];
      }
    });
  }
}
